export const Pakbankname = [
  "ABHI FINANCE SERVICES LIMITED",
  "AFT",
  "AFT IBFT",
  "Advans",
  "Al Meezan Investment Management Limited",
  "AlHabib",
  "Albarka",
  "Alfalah",
  "Allied",
  "Apna",
  "Askari",
  "BOK",
  "BYKEA",
  "BankIslami",
  "Burj",
  "Central Directorate of National Savings",
  "Central Directorate of National Savings (CDNS)",
  "Central Directorate of National Savings (CDNS) – 1IBFT IMD Addition",
  "Citi",
  "DubaiIslamic",
  "EZ wage",
  "EasyPaisa",
  "FINCA",
  "FINJA",
  "FWBL",
  "Faysal",
  "First Microfinance Bank",
  "HBL",
  "HBL ASSET MANAGEMENT",
  "Habib Metro Bank – Bulk 1IBFT",
  "HabibMetro",
  "Humrah Financial Services",
  "ICBC",
  "JS",
  "KASB",
  "KBL",
  "KEENU",
  "KEENU Bank",
  "KEENU – IMD and 1IBFT Screen Addition",
  "Keenu1",
  "MCB",
  "MCB-Arif Habib",
  "MIB",
  "Meezan",
  "MobilinkBank Pakistan",
  "NAYAPAY",
  "NBP",
  "NBP Fund Management Limited",
  "NBP1",
  "NIB",
  "NRSP",
  "National Bank",
  "Numbers Private Limited",
  "PayMax",
  "PayMax1",
  "PunjabBank",
  "SADAPAY",
  "SCB",
  "SEEDCREED Financial Services Limited",
  "SIMPAISA",
  "SIND",
  "Samba",
  "Silk",
  "SindhBank",
  "Soneri",
  "Summit",
  "TAG",
  "TezPAy",
  "UBL",
  "UPaisa",
  "Waseela",
  "Waseela bank",
  "ZTBL1",
  "Zarai Taraqiati Bank",
  "JazzCash",
  "U Bank",
  "HBL Express",
  "UBL Omni",
];
